import React from "react";
import { Link } from "react-router-dom";

interface FilterHeaderProps {
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    selectedSort: string;
    setSelectedSort: (sort: string) => void;
    employeeRoleOptions: Array<{ key: string; label: string; id: number | null }>;
    selectedRoleFilter: string;
    setSelectedRoleFilter: (key: string) => void;
}

const FilterHeaderEmployee: React.FC<FilterHeaderProps> = ({
    selectedStatus,
    setSelectedStatus,
    selectedSort,
    setSelectedSort,
    employeeRoleOptions,
    selectedRoleFilter,
    setSelectedRoleFilter
}) => {
    const currentRoleLabel =
        employeeRoleOptions.find((x) => x.key === selectedRoleFilter)?.label ||
        "All Employees";

    return (
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>Employee List</h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white"
                        data-bs-toggle="dropdown"
                    >
                        {currentRoleLabel}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {employeeRoleOptions.map((opt) => (
                            <li key={opt.key}>
                                <Link
                                    to="#"
                                    className="dropdown-item"
                                    onClick={() => setSelectedRoleFilter(opt.key)}
                                >
                                    {opt.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white"
                        data-bs-toggle="dropdown"
                    >
                        {selectedStatus}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {["All", "active", "inactive"].map((status) => (
                            <li key={status}>
                                <Link
                                    to="#"
                                    className="dropdown-item"
                                    onClick={() => setSelectedStatus(status)}
                                >
                                    {status}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="dropdown">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white"
                        data-bs-toggle="dropdown"
                    >
                        {selectedSort ? `Sort By: ${selectedSort}` : "Sort By : Last 7 Days"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {[
                            "Recently Added",
                            "Ascending",
                            "Descending",
                            "Last Month",
                            "Last 7 Days"
                        ].map((sort) => (
                            <li key={sort}>
                                <Link
                                    to="#"
                                    className="dropdown-item"
                                    onClick={() => setSelectedSort(sort)}
                                >
                                    {sort}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default FilterHeaderEmployee;
